import { get } from 'lodash-es';

import Fuse from 'fuse.js';

const removeAccents = (str) => str.normalize('NFD').replace(/[\u0300-\u036F]/g, '');

const findBy = (name, list, keys) => {
  const options = {
    keys,
    shouldSort: true,
    includeMatches: true,
    distance: 1000,
    minMatchCharLength: name.length,
    getFn: (obj, path) => {
      // Use the default `get` function
      const value = Fuse.config.getFn(obj, path);
      // ... do something with `value`
      return removeAccents(value);
    },
  };
  const fuse = new Fuse(list, options);
  const results = fuse.search(name);
  return results.slice(0, 30);
};

const spanify = (text, cssClass = false) => `<span ${cssClass
  ? `class="${cssClass}"` : ''}>${text}</span>`;

const hightlightBuilder = (researchedCountry, keyName) => {
  const name = get(researchedCountry.item, keyName);
  const htmlString = [];
  const add = (substring) => { htmlString.push(spanify(substring)) };
  const highlight = (substring) => {
    htmlString.push('<span class="text-primary font-weight-bold">');
    add(substring);
    htmlString.push('</span>');
  };
  const nameFormated = [...researchedCountry.matches]
    .filter(({ key }) => key === keyName)
    .map(({ indices }) => {
      add('<span>');
      let lastIndice = 0;
      for (let i = 0; i < indices.length; i += 1) {
        const [startIndice, endIndice] = indices[i];
        if (startIndice !== 0) {
          add(name.substring(lastIndice, startIndice));
        }
        highlight(name.substring(startIndice, endIndice + 1));
        lastIndice = endIndice + 1;
      }
      add(name.substring(lastIndice));
      add('</span>');
      return htmlString.join('');
    });
  return nameFormated.length > 0 ? nameFormated : spanify(name);
};

const breadcrumb = (researchedCountry) => `${hightlightBuilder(researchedCountry, 'name')}`;

export {
  breadcrumb,
  findBy,
};
